<template>
  <div class="search-bar-wrapper">
    <!-- Search Bar -->
    <div class="search-bar" :class="{ focused }">
      <img src="@/assets/icons/search.svg" alt="Son Aramalar" class="section-icon" />
      <input
        type="text"
        v-model="query"
        @focus="handleFocus"
        @input="handleInput"
        :placeholder="$t('search.placeholder')"
      />
      <span class="close-icon" v-if="focused" @click="handleClose">✖</span>
    </div>

    <!-- Expandable Area -->
    <transition name="slide-down">
      <div v-if="focused" class="search-results-panel">

        <!-- Arama Sonuçları -->
        <div v-if="query.trim().length > 1 && results.length > 0" class="section">
          <div class="section-header">
           <img src="@/assets/icons/promo.svg" alt="Sonuçlar" class="section-icon" />
          <h4 class="section-title">{{ $t('search.result') }}</h4>
          </div>
          <div class="scroll-row">
            <div
  v-for="game in results"
  :key="game._id"
  class="game-card"
  @click="launchGame(game)"
>
              <img class="game-banner" :src="fullImg(game.banner)" :alt="game.game_name" />
              <div class="game-info">
                <div class="game-name">{{ game.game_name }}</div>
                <div class="provider-code">{{ game.provider?.name || game.provider_code }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Son Aramalar -->
        <div class="section">
          <div class="section-header">
          <img src="@/assets/icons/clock.svg" alt="Son Aramalar" class="section-icon" />
          <h4 class="section-title"> {{ $t('search.lastsearch') }}</h4>
          </div>
          <div class="recent-searches">
            <span
              v-for="(item, index) in recentSearches"
              :key="index"
              class="tag"
              @click="query = item"
            >
              {{ item }}
            </span>
            <span v-if="recentSearches.length === 0"> {{ $t('search.nosearch') }}</span>
          </div>
        </div>

        <!-- Önerilen Oyunlar -->
        <div class="section">
          <div class="section-header">
          <img src="@/assets/icons/thumbup.svg" alt="Önerilenler" class="section-icon" />
          <h4 class="section-title"> {{ $t('search.likesearch') }}</h4>
          </div>
          <div class="scroll-row">
            <div
  v-for="game in featuredGames"
  :key="game._id"
  class="game-card"
  @click="launchGame(game)"
>
              <img class="game-banner" :src="fullImg(game.banner)" :alt="game.game_name" />
              <div class="game-info">
                <div class="game-name">{{ game.game_name }}</div>
                <div class="provider-code">{{ game.provider?.name || game.provider_code }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Search',
  data() {
    return {
      query: '',
      focused: false,
      results: [],
      featuredGames: [],
      recentSearches: [],
      searchTimeout: null // <-- debounce için
    };
  },
  methods: {
    launchGame(game) {
    this.$router.push({ name: 'GameStart', params: { id: game.game_code } });
  },
    handleFocus() {
      this.focused = true;
    },
    handleClose() {
      this.query = '';
      this.focused = false;
      this.results = [];
    },
    handleInput() {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        const q = this.query.trim();
        if (q.length > 1) {
          axios
            .get(`/public/games/search?query=${q}`)
            .then(res => {
              this.results = res.data;
            })
            .catch(() => (this.results = []));

          if (!this.recentSearches.includes(q)) {
            const updated = [q, ...this.recentSearches.slice(0, 9)];
            this.recentSearches = updated;
            localStorage.setItem('recentSearches', JSON.stringify(updated));
          }
        } else {
          this.results = [];
        }
      }, 1000); // 1 saniye bekleme süresi
    },
    fullImg(path) {
      if (!path) return '';
      if (path.startsWith('http')) return path;
      return process.env.VUE_APP_BACKEND_URL + path;
    }
  },
  created() {
    this.recentSearches = JSON.parse(localStorage.getItem('recentSearches') || '[]');
    axios
      .get('/public/games/featured/list?limit=15')
      .then(res => (this.featuredGames = res.data))
      .catch(() => (this.featuredGames = []));
  }
};

</script>

<style scoped>

.search-bar-wrapper {
  width: 100%;
      padding-left: 3px;
    padding-right: 3px;
  
}


.search-bar {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--search-bg);
  padding: 10px 16px;
  border-radius: 5px;
  color: white;
  transition: all 0.3s ease;
  z-index: 1;
  overflow: hidden;
      outline: var(--outline) solid 2px;
}

 

.search-bar input {
  background: transparent;
  border: none;
  outline: none;
  flex: 1;
  color: white;
  font-size: 16px;
  margin-left: 10px;
}


.search-icon,
.close-icon {
  font-size: 18px;
  cursor: pointer;
}
.search-results-panel {
  position: relative;
  overflow: hidden;
  border-radius: 0 0 5px 5px;
  padding: 20px;
  color: white;
  background: var(--search2-bg);
  transition: all 0.3s ease;
  z-index: 1;
  margin-top: -3px;
}

 


.section {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.section-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.section-title {
  font-weight: bold;
  margin: 0;
  font-size: 14px;
}

.scroll-row {
  display: flex;
  overflow-x: auto;
  gap: 15px;
}
.scroll-row::-webkit-scrollbar {
  height: 6px;
}
.scroll-row::-webkit-scrollbar-thumb {
  background: #ffffff22;
  border-radius: 5px;
}
.game-card {
  width: 150px;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
  transition: transform 0.2s ease;
}
.game-card:hover {
  transform: scale(1.02);
}

.game-banner {
  width: 100%;

}
.game-info {
  padding: 8px;
}
.game-name {
  font-size: 14px;
  font-weight: bold;
}
.provider-code {
  font-size: 12px;
  color: #ccc;
}
.recent-searches .tag {
  background: var(--search-bg);
  padding: 6px 10px;
  border-radius: 5px;
  margin: 4px 6px 0 0;
  display: inline-block;
  cursor: pointer;
}
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 1024px) {
 
  .search-bar-wrapper {
  padding-left: 10px;
  padding-right: 10px;
  
}
}
</style>
